import { useEdgeMutation } from '@app/data/edge/hooks';
import DELETE_LIST from '../mutations/deleteList';
import { RemoveListMutation } from '../mutations/__generated__/deleteList.types';

const useRemoveList = () => {
  const {
    mutatefn: removeList,
    loading: isLoading,
    error,
  } = useEdgeMutation<RemoveListMutation>(DELETE_LIST);

  return {
    removeList,
    isLoading,
    error,
  };
};

export default useRemoveList;
